import { defineComponent, toRefs, computed, getCurrentInstance, Text, resolveComponent, openBlock, createElementBlock, normalizeClass, normalizeStyle, createElementVNode, toDisplayString, createCommentVNode, createBlock, withCtx, renderSlot, Fragment } from 'vue';
import '../../fold-text/index2.js';
import '../../bms-user-menu/index2.js';
import '../../select/index2.js';
import { TEllipsisText } from '../../ellipsis-text/index2.js';
import '../index2.js';
import { getFormattedGutterValue } from './utils2.js';
import _export_sfc from '../../../_virtual/plugin-vue_export-helper.js';

const _sfc_main = defineComponent({
  name: "TDescriptionItem",
  props: {
    label: {
      type: String,
      required: true
    },
    span: {
      type: Number,
      default: void 0
    },
    width: {
      type: String,
      default: void 0
    },
    labelClassName: {
      type: String,
      default: void 0
    },
    contentClassName: {
      type: String,
      default: void 0
    },
    showOverflowTooltip: {
      type: Boolean,
      default: false
    },
    contentMaxLine: {
      type: Number,
      default: 1
    },
    direction: {
      type: String,
      default: void 0
    }
  },
  components: {
    TEllipsisText
  },
  setup(props, { slots }) {
    const { width, span, direction } = toRefs(props);
    const parentComponent = computed(() => {
      var _a;
      const parent = (_a = getCurrentInstance()) == null ? void 0 : _a.parent;
      if ((parent == null ? void 0 : parent.type.name) !== "TDescription") {
        throw new Error("TDescriptionItem \u7EC4\u4EF6\u4EC5\u80FD\u5728 TDescription \u7EC4\u4EF6\u4E0B\u4F7F\u7528");
      }
      return parent;
    });
    const column = computed(() => {
      var _a, _b;
      return (_b = (_a = parentComponent.value.props) == null ? void 0 : _a.column) != null ? _b : 12;
    });
    const gutter = computed(() => {
      var _a, _b;
      return getFormattedGutterValue((_b = (_a = parentComponent.value) == null ? void 0 : _a.props) == null ? void 0 : _b.gutter);
    });
    const itemWidth = computed(() => {
      if (typeof width.value === "string") {
        return width.value;
      }
      if (typeof span.value !== "number") {
        throw new Error("TDescriptionItem \u7EC4\u4EF6\u7684 width \u4E0E span \u5C5E\u6027\u81F3\u5C11\u4F20\u5165\u4E00\u4E2A");
      }
      return `${span.value / column.value * 100}%`;
    });
    const computedDirection = computed(() => {
      var _a, _b;
      return (_b = direction.value || ((_a = parentComponent.value.props) == null ? void 0 : _a.direction)) != null ? _b : "horizontal";
    });
    const children = computed(() => (slots == null ? void 0 : slots.default) ? slots.default() : []);
    const childrenIsString = computed(() => children.value.every((child) => child.type === Text));
    return {
      gutter,
      itemWidth,
      childrenIsString,
      computedDirection
    };
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _a, _b, _c, _d;
  const _component_t_ellipsis_text = resolveComponent("t-ellipsis-text");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["t-description-item", _ctx.computedDirection === "vertical" ? "vertical-layout" : null]),
    style: normalizeStyle({
      width: _ctx.itemWidth,
      padding: `${(_b = (_a = _ctx.gutter) == null ? void 0 : _a[0]) != null ? _b : 8}px ${(_d = (_c = _ctx.gutter) == null ? void 0 : _c[1]) != null ? _d : 10}px`
    })
  }, [
    createElementVNode("div", {
      class: normalizeClass(["t-description-item__label", _ctx.labelClassName])
    }, toDisplayString(_ctx.label) + ":", 3),
    createElementVNode("div", {
      class: normalizeClass(["t-description-item__content empty-placeholder", _ctx.contentClassName])
    }, [
      createCommentVNode(" \u5982\u679C\u4F20\u5165\u7684\u662F\u7EAF\u5B57\u7B26\u4E32\uFF0C\u4E14\u5F00\u542F\u4E86 showOverflowTooltip\uFF0C\u5C31\u5C06\u5176\u6E32\u67D3\u5230 ellipsis-text \u4E2D "),
      _ctx.childrenIsString && _ctx.showOverflowTooltip ? (openBlock(), createBlock(_component_t_ellipsis_text, {
        key: 0,
        line: _ctx.contentMaxLine,
        placement: "top",
        "content-class": "empty-placeholder"
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["line"])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
        createCommentVNode(" \u5426\u5219\uFF0C\u6E32\u67D3\u4E3A\u7EAF\u63D2\u69FD "),
        renderSlot(_ctx.$slots, "default")
      ], 2112))
    ], 2)
  ], 6);
}
var DescriptionItem = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/b2b-fe-repository/trade-ui/packages/components/description/src/description-item.vue"]]);

export { DescriptionItem as default };
//# sourceMappingURL=description-item.vue2.js.map
